<div class="flex gap-4 items-center">
    @if (dataSourceState$ | async; as dataSourceState) {
        @if (dataSourceState.loading) {
            {{ 'LOADING.DATA_SOURCE' | delayDisplay | translate }}
        } @else {
            <div class="flex flex-wrap" [caLayout]="slot().layout" [caLayoutGap]="0" (blur)="onTouched()" tabindex="0">
                @for (item of dataSourceMapping || dataSourceState.dataSource.items; track item.value) {
                    <div class="flex items-center gap-4" [formGroup]="formGroup">
                        @let tooltip = slot() | slotTooltip: item.value;
                        <mat-checkbox
                            class="ca-checkbox"
                            [class.ca-checkbox-with-visual]="isVisual || tooltip"
                            [disableRipple]="true"
                            [formControlName]="$any(item.value)"
                            [checked]="isSelected(item.value)"
                            (change)="onCheckboxChange($event, item.value)"
                        >
                            @if (isVisual) {
                                <ca-visual [slot]="slot()" [value]="item.value"></ca-visual>
                            } @else {
                                <div class="flex items-center gap-2 pr-2">
                                    @let slotTitle = slot().titleKey | translationKey: slot().titleData : item.value;
                                    @if (slotTitle) {
                                        <span>{{ slotTitle }}</span>
                                    }
                                    @if (tooltip) {
                                        <ca-visual [tooltip]="tooltip"></ca-visual>
                                    }
                                </div>
                            }
                        </mat-checkbox>
                    </div>
                }
            </div>
        }
    } @else {
        <div class="relative" [formGroup]="formGroup">
            @let title = slot().titleKey | translationKey: slot().titleData;
            @let tooltip = slot() | slotTooltip;
            <mat-checkbox
                class="ca-checkbox"
                [class.ca-checkbox-with-visual]="isVisual || tooltip"
                [attr.aria-label]="title"
                [formControl]="control"
                [disableRipple]="true"
                [checked]="value()"
                [disabled]="!!isDisabled"
                (change)="onValueChange($event.checked)"
                (blur)="onTouched()"
            >
                @if (slot().visual) {
                    <ca-visual [slot]="slot()" [iconSize]="24"></ca-visual>
                } @else {
                    <div class="flex items-center gap-2 pr-2">
                        @if (title) {
                            <span>{{ title }}</span>
                        }
                        @if (tooltip) {
                            <ca-visual [tooltip]="tooltip"></ca-visual>
                        }
                    </div>
                }
            </mat-checkbox>
        </div>
    }
</div>
@if (isErrorMessage) {
    <div class="ca-subscript relative">
        <div class="absolute ca-error-message" @slideDown>
            <ca-form-error-message>
                {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
            </ca-form-error-message>
        </div>
    </div>
}
